<template>
  <div>
    <div class="lds-facebook"  v-if="!loading"><div></div><div></div><div></div></div>
      <a-card title="All applications" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="addNewApplication()">Add</a-button>
        <table class="table table-sm" v-if="getall">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Url</th>
              <th scope="col">Acounts</th>
              <th scope="col">Basic Rooms</th>
              <th scope="col">Licensed Rooms</th>
              <th scope="col">Total Rooms</th>
              <th scope="col">Institutions</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in applications" :key="i">
              <th scope="row">{{item.ew_app_id}}</th>
              <th scope="row">{{item.ew_app_name}}</th>
              <th scope="row">{{item.ew_url}}</th>
              <th scope="row">{{item.accounts.nr_account}}</th>
              <th scope="row">{{item.basic_rooms.nr_rooms}}</th>
              <th scope="row">{{item.licensed_rooms.nr_rooms}}</th>
              <th scope="row">{{item.basic_rooms.nr_rooms + item.licensed_rooms.nr_rooms}}</th>
              <th scope="row">{{item.institutions.length}}</th>
              <th scope="row">
                <router-link :to="{ path: '/application/'+item.ew_app_id}" class="btn-info btn-sm" exact> <span class="ti-book" title="View / Edit application details"></span></router-link>
                |
                <a-popconfirm
                    title="Are you sure delete this application?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="deleteApp(item.ew_app_id)"
                    @cancel="cancel"
                >
                    <a-button type="danger" title="Delete!" size="small">
                        <span class="ti-trash"></span>
                    </a-button>
                </a-popconfirm>
              </th>
            </tr>
          </tbody>
        </table>

      </a-card>
      <a-modal
          :footer="null"
          title="Add new application!"
          :visible="visible"
          @cancel="handleCancelAction"
          >
          <a-row>
            <form @submit="handleSubmit" id="form_zoom">

              <a-form-item label="App name" >
                <a-input id="app_name" name="app_name" v-model="form.name" placeholder="Application app_name" required/>
              </a-form-item>
              <a-form-item label="Secret" >
                <a-input id="secret" name="secret" v-model="form.secret" placeholder="Application secret" minlength="20" required/>
              </a-form-item>
              <a-form-item label="Url" >
                <a-input addon-before="https://" id="url" name="url" v-model="form.url" placeholder="Application url" required/>
              </a-form-item>
              <a-form-item label="Logo" >
                <input type="file" id="logo" name="logo" required>
              </a-form-item>
              <button type="submit" class="btn btn-outline-success waves-effect waves-themed pull-right">Save</button>
            </form>
        </a-row>
      </a-modal>
  </div>
</template>
<script>
const columns_users = [
  {
    title: 'Name',
    key:'name',
    dataIndex: 'name',
    width: 150,
  },
  {
    title: 'Email',
    key:'email',
    dataIndex: 'email',
    width: 150,
  }
];
const columns_institutions = [
  {
    title: 'Institution Id',
    key:'ew_ins_id',
    dataIndex: 'ew_ins_id',
    width: 150,
  },
  {
    title: 'Institution Name',
    key:"ew_ins_name",
    dataIndex: 'ew_ins_name',
    width: 150,
  }
];

import API from '../../services/api';
import store from '../../store/index.js'
export default {
  data() {
    return {
        loading:false,
        applications:[],
        columns_users,
        columns_institutions,
        secret:this.$route.params.id,
        is_login: false,
        user_email: this.$route.query.user_email,
        visible:false,
        form: {
          name:'',
          url:'',
          secret:''
        },
        getall:false
    };
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
      this.handleLogin();
  },
  methods: {
      async handleLogin(){
        await API.post(`/api/admin/login/${this.secret}`,{email: this.user_email})
          .then(({data,status}) => {
            if(data.errorCode == 1){
              if(status == 400){
                this.$notification["error"]({
                    message: "Error",
                    description: data.errorMessage,
                  });
              }
            }
            if(data.errorCode == 0){
               const resp = data.data
                if (resp.access_token) {
                  localStorage.setItem('access_token', resp.access_token);
                  this.$store.dispatch('auth/getUser')
                  .then(response => {
                    store.commit('auth/getUserSuccess',response.data.profile)
                    this.getApplications();
                    this.is_login = true
                    this.$router.push('/admin')
                })
              }
             }
            
          }).catch(error => {
            this.$router.push('/login')
          })
    },
    async addNewApplication(){
       this.visible = true
    },
    async handleSubmit(e) {
     e.preventDefault();
        var formel       = 	document.getElementById('form_zoom');
        var formData = new FormData(formel);
        API.post(`/api/admin/applications`,formData)
        .then(response => {
           this.resetForm()
           this.visible = false;
           this.getApplications()
          
        })
    },
    handleCancelAction(e) {
        this.visible = false;
    },
    cancel(e) {
    },
    deleteApp(id){
      API.delete(`/api/admin/applications/${id}`)
      .then(response => {
          this.$message.success('Deleted successfully!')
          this.getApplications()
      })
    },
    async resetForm(){
      document.getElementById("logo").value = "";
       this.form = {
          name:'',
          url:'',
          secret:''
        }
    },
    async getApplications(){
        API.get(`/admin/${this.userLogin.email}/applications`)
        .then(res => { 
            let apps = [...res.data.applications]
            this.applications = res.data.applications
            console.log(this.applications)
            this.getall = true

            this.loading = true
        })
        .catch(error => console.log(error));
        
    },
    handleClick(event,id){
        event.stopPropagation();
        this.$router.push(`/application/${id}`)
    }
  }
};
</script>
<style>
</style>
